<template>
  <BContainer
    v-if="currentUser"
    class="mb-4 px-0"
    fluid
  >

    <div class="py-2 w-100 border-bottom font-weight-bold text-muted mb-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>My Activities this {{ monthLongFormatter(schedule) }}</div>
        <div>
          <BButton
            size="sm"
            variant="link"
            :to="{
              name: 'fso.to-dos.activity-recordings'
            }"
          >
            <i class="far fa-circle-arrow-right fa-lg m-0 p-0" />
          </BButton>
        </div>
      </div>
    </div>

    <BRow
      v-if="busy"
      class="my-3"
    >
      <BCol
        cols="12"
      >
        <div class="text-center py-5">
          <BIcon
            icon="stopwatch"
            font-scale="5"
            animation="cylon"
          />
          <p class="h6 py-2">
            <strong>Loading . . .</strong>
          </p>
        </div>
      </BCol>
    </BRow>

    <BRow
      v-else-if="activities.length === 0"
    >
      <BCol
        cols="12"
        class="text-center py-5"
      >
        <BIcon
          icon="calendar"
          font-scale="4"
        />
        <p class="h6 py-2">
          <strong>No activities found</strong>
        </p>
      </BCol>
    </BRow>

    <BRow
      class="gap-y-2 mb-3 px-2"
    >
      <BCol
        v-for="(activity, index) in activities"
        :key="index"
        cols="12"
        md="4"
        class="px-1"
      >
        <BCard
          body-class="p-2"
          class="rounded-lg"
        >
          <BCardText>
            <div class="d-flex align-items-center gap-2">
              <h5>{{ activity?.total }}</h5>
              <RouterLink
                :to="{
                  name: 'fso.to-dos.activity-recordings',
                  params: {
                    activity: activity?.activity_id || 0
                  }
                }"
                style="font-size: 0.8rem;"
                class="font-weight-bold"
              >
                {{ activity?.activity?.activity_name || '' }}
              </RouterLink>
            </div>
          </BCardText>
        </BCard>
      </BCol>
    </BRow>

  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'

// import Products from '@/views/fso/task-events/components/Products.vue'

export default {
  name: 'FSODashboardActivities',

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  props: {
    busy: {
      type: Boolean,
      required: true,
      default: false
    },
    schedule: {
      type: String,
      required: true,
      default: ''
    },
    activities: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  computed: mapGetters({
    currentUser: 'auth/user'
  })
}
</script>
